<template>

  <v-container class="text-center">
    <v-row>
      <template>
        <v-toolbar flat>
          <v-spacer />

          <v-col class="pa-17">
            <v-text-field v-model="anio" label="Año" outlined dense hide-details></v-text-field>
          </v-col>

          <v-col class="pa-17">
            <v-autocomplete v-model="mes" :items="items_mes" item-text="mes" item-value="id_mes" label="Mes" outlined
              dense hide-details>
            </v-autocomplete>
          </v-col>

          <v-col class="pa-17">
            <v-autocomplete v-model="sucursal" :items="items_sucursales" item-text="nombre" item-value="id_sucursal"
              label="Sucursal" outlined dense hide-details>
              <template v-slot:selection="data">
                {{ data.item.cod_sucursal }} {{ data.item.nombre }}
              </template>
              <template v-slot:item="data">
                {{ data.item.cod_sucursal }} {{ data.item.nombre }}
              </template>
            </v-autocomplete>
          </v-col>

          <v-spacer />

          <v-dialog v-model="dialog_select_download" persistent max-width="900px" class="dialog-custom">
            <v-card>
              <v-card-title class="text-h6">Descargar Archivo CSV</v-card-title>
              <v-card-actions class="actions-custom">
                <v-btn color="cyan" @click="descargarArchivo('csv')" class="btn-custom">CSV</v-btn>
                <v-btn color="green" @click="dialog_select_download = false" class="btn-custom-cancel">Cancelar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog_preview_report" fullscreen persistent>
            <v-toolbar flat dense>
              <v-toolbar-title> DOCUMENTO </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon @click="dialog_preview_report = !dialog_preview_report">far fa-times-circle</v-icon>
            </v-toolbar>
            <iframe :src="base64_doc" id="myPDF" frameborder="0" />
          </v-dialog>

         
          <template v-slot:extension>
            <v-row justify="center" class="py-2">  
            <!-- --- <v-checkbox v-model="con_detalle" label="Con Detalle" dense hide-details /> --- -->
            </v-row>
          </template>
        </v-toolbar>
      </template>

    </v-row>
    <v-row justify="center" class="button-row">
      <v-col cols="auto" class="text-center">
        <v-btn class="button-custom" elevation="6" fab color="cyan" @click="abrirModalDescarga">
          <img src="@/assets/factura.png" alt="Factura" class="button-image" />
        </v-btn>
        <div class="button-label text-gradient">Facturas</div>
      </v-col>
    </v-row>


    <v-row justify="center">

    </v-row>

    <v-snackbar v-model="snackbar" timeout="4000" color="blue" multi-line elevation="24" outlined top right>
      <v-icon>fa-solid fa-circle-info</v-icon>
      {{ snackbar_text }}
    </v-snackbar>

  </v-container>
</template>

<script>


import axios from "axios";


export default {
  name: 'CircularButtons',
  data() {
    return {

      anio: "2025",
      mes: "",
      sucursal: "",



      dialog_preview_report: false,
      base64_doc: "",


      items_compras: [],
      items_sucursales: [],
      items_mes: [],
      items_fac: [],

      loading_compras: false,

      snackbar: false,
      snackbar_text: "",

      dialog_select_download: false,

      con_detalle: false,
      detalles_por_factura: {},
    }
  },

  created() {
    this.listarSucursales();
    this.listarMes();
    this.listarProveedores();
    this.listarClientes();

  },

  methods: {

    abrirModalDescarga() {
      this.dialog_select_download = true;
    },


    descargarArchivo(tipo) {
      if (tipo === 'pdf') {
        this.descargarFacturas();
      } else if (tipo === 'csv') {

        this.obtenerDatosParaCSV();
      }
      this.dialog_select_download = false;
    },


    async obtenerDatosParaCSV() {
      try {
        this.loading_compras = true;
        this.detalles_por_factura = {};

        const { data } = await axios.get(
          `api/Facturas/ListarAscendente/${this.$store.state.emp.id_empresa}`
        );

        const facturasData = data
          .filter(f => {
            const d = new Date(f.fecha);
            return d.getFullYear() === +this.anio && d.getMonth() + 1 === +this.mes;
          })
          .map(f => {
            const cli = this.getClienteByIdLocal(f.id_cliente) || {};
            return {
              ...f,
              nit: cli.id_identificador == 1 ? (cli.documento || "").replace(/-/g, "") : "",
              dui: cli.id_identificador == 2 ? (cli.documento || "").replace(/-/g, "") : "",
              nombre: cli.nombre || "No disponible"
            };
          });


        if (!facturasData.length) {
          throw new Error("No hay documentos para el año/mes seleccionados");
        }

        // Si el usuario NO pidió detalle, se descarga directo
        if (!this.con_detalle) {
          this.descargarCSVFacturas(facturasData);
          return;
        }

        // Traer detalle en paralelo
        await Promise.all(
          facturasData.map(f =>
            axios.get(`api/DetalleCompras/Listar/${f.id_factura}`)
              .then(r => this.$set(
                this.detalles_por_factura,
                f.id_factura,
                Array.isArray(r.data) ? r.data : []
              ))
          )
        );

        this.descargarCSVFacturas(facturasData, true);

      } catch (err) {
        this.snackbar_text = err.message || "Error inesperado";
        this.snackbar = true;
      } finally {
        this.loading_compras = false;
      }
    },



    getProveedorByIdLocal(id_proveedor) {
      if (this.items_proveedores && this.items_proveedores[id_proveedor]) {
        return this.items_proveedores[id_proveedor];
      }
      return null;
    },

    getClienteByIdLocal(id_cliente) {
      if (this.items_clientes && this.items_clientes[id_cliente]) {
        return this.items_clientes[id_cliente];
      }
      return null;
    },


    listarFacturas() {
      this.loading_facturas = true;
      axios
        .get("api/Facturas/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items = response.data;
          this.loading_facturas = false;
        })
        .catch(() => {
          this.loading_facturas = false;
        });
    },


    listarSucursales() {
      axios
        .get("api/Sucursales/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_sucursales = response.data;
          this.sucursal = response.data[0].id_sucursal;
        });
    },

    listarMes() {
      axios.get("api/Mes/Listar")
        .then((response) => {
          this.items_mes = response.data;
        });
    },

    // Listar todos los proveedores 
    listarProveedores() {
      return axios
        .get("api/Proveedores/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_proveedores = response.data.reduce((map, proveedor) => {
            map[proveedor.id_proveedor] = proveedor;
            return map;
          }, {});


        })
        .catch((error) => {
          console.error("Error al listar los proveedores:", error);
          this.snackbar_text = "No se pudieron cargar los proveedores";
          this.snackbar = true;
        });
    },

    listarClientes() {
      return axios
        .get("api/Clientes/ListarTodos/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_clientes = response.data.reduce((map, cliente) => {
            map[cliente.id_cliente] = cliente;
            return map;
          }, {});


        })
        .catch((error) => {
          console.error("Error al listar los clientes:", error);
          this.snackbar_text = "No se pudieron cargar los clientes";
          this.snackbar = true;
        });
    },




    descargarFacturas() {
      if (this.$store.state.emp.id_empresa) {
        this.loading_facturas = true;


        axios.get("api/Facturas/ListarAscendente/" + this.$store.state.emp.id_empresa)
          .then(response => {
            if (Array.isArray(response.data)) {

              const ccfData = response.data.filter(item => {
                const fecha = new Date(item.fecha);
                const itemAnio = fecha.getFullYear();
                const itemMes = fecha.getMonth() + 1;

                return itemAnio === parseInt(this.anio) && itemMes === parseInt(this.mes);
              }).map(item => {

                const cliente = this.getClienteByIdLocal(item.id_cliente);
                if (cliente) {
                  item.nit = cliente.id_identificador == "1" && cliente.documento
                    ? cliente.documento.replace(/-/g, "")
                    : "";

                  item.dui = cliente.id_identificador == "2" && cliente.documento
                    ? cliente.documento.replace(/-/g, "")
                    : "";

                  item.nombre = cliente.nombre || "No disponible";
                  item.direccion = cliente.direccion || "No disponible";
                  item.registro = cliente.registro || "No disponible";
                  item.correo1 = cliente.correo1 || "No disponible";
                } else {
                  item.nit = "N/A";
                  item.dui = "N/A";
                  item.nombre = "Cliente no encontrado";
                }
                return item;
              });


              const id_factura = ccfData.map(item => item.id_factura);


            } else {
              this.snackbar_text = "Error en la respuesta del servidor";
              this.snackbar = true;
              this.loading_facturas = false;
            }
          })
          .catch(error => {
            this.snackbar_text = "No se pudo descargar el archivo CCF";
            this.snackbar = true;
            this.loading_facturas = false;
          });
      } else {
        console.error("El id_empresa es undefined");
      }
    },


    descargarCSVFacturas(facturas, conDetalle = false) {
      const csvContent = conDetalle
        ? this.generarCSVFacturasConDetalle(facturas)
        : this.generarCSVFacturas(facturas);

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", `Exportacion_${this.anio}_${String(this.mes).padStart(2, "0")}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },


    generarCSVFacturasConDetalle(facturas) {
      const header = [
        "Fecha", "Resolucion", "Codigo de Generacion", "Numero de Control", "Tipo DOC",
        "NIT", "Nombre Cliente", "Correo", "Direccion", "Registro", "IVA", "Descuento",
        "Exentas", "Gravadas", "No Sujetas", "Retencion", "Percepcion",
        "Total Operacion", "Total a Pagar", "DUI", "Anulado",
        "id_detalle_factura", "id_factura", "precio", "descuento_det", "total_det",
        "cantidad", "cod_servicio", "descripcion", "exento", "no_sujeto"
      ].join(";");

      const filas = [];

      facturas.forEach(f => {
        // Tipo de documento fiscal para esta factura
        const tipoDocumento = (() => {
          if (f.id_tipo_doc_fiscal == "10") return "CCF";
          if (f.id_tipo_doc_fiscal == "11") return "FAC";
          return "";
        })();

        const detalles = this.detalles_por_factura[f.id_factura] || [];
        if (!detalles.length) detalles.push({});

        detalles.forEach(d => {
          filas.push([
            this.formatDate(f.fecha),
            f.sello_recepcion,
            f.codigo_generacion,
            f.numero_control,
            tipoDocumento,
            f.nit,
            f.nombre,
            f.correo1,
            f.direccion,
            f.registro,
            f.iva ?? "0.00",
            f.descuento ?? "",
            f.exentas ?? "",
            f.gravadas ?? "",
            f.no_sujetas ?? "",
            f.retencion ?? "",
            f.percepcion ?? "",
            f.total_operacion ?? "",
            f.total_pagar ?? "",
            f.dui ?? "",
            f.resolucion_invalidacion ?? "",

            d.id_detalle_factura ?? "",
            d.id_factura ?? "",
            d.precio ?? "",
            d.descuento ?? "",
            d.total ?? "",
            d.cantidad ?? "",
            d.cod_servicio ?? "",
            (d.descripcion || "").replace(/(\r|\n|;)/g, " "),
            d.exento ?? "",
            d.no_sujeto ?? ""
          ].join(";"));
        });
      });

      return [header, ...filas].join("\n");
    },





    generarCSVFacturas(data) {

      const filteredData = data.filter(row => {
        const fecha = new Date(row.fecha);
        return fecha.getFullYear() === parseInt(this.anio) &&
          (fecha.getMonth() + 1) === parseInt(this.mes);
      });


      const header = [
        "Fecha", // A: Fecha Emisión (DD/MM/AAAA)
        "Resolucion", // B: Número de Serie (Sello de Recepción)
        "Codigo de Generacion", // C: Número de Documento (Código de Generación)
        "Numero de Control", // D: Número de Control
        "Tipo DOC", // E: Tipo de Documento (FEX)
        "NIT", // F: NIT Cliente sin guiones (Solo si id_identificador === "1")
        "Nombre Cliente", // G: Nombre Cliente
        "Correo", // H: Correo 1
        "Direccion", // I: Dirección
        "Registro", // J: Registro
        "IVA", // K: Débito Fiscal
        "Descuento", // L: Descuento
        "Gravadas", // M: Gravadas
        "Exentas", // N: Exentas
        "No Sujetas", // O: No Sujetas
        "Retencion", // P: Retención
        "Percepcion", // Q: Percepción
        " Total Operacion", // R: Tipo de Operación
        "Total a Pagar", // S: Total a Pagar
        "DUI", // T: DUI Cliente (Solo si id_identificador === "2")
        "Anulado", // U: Resolución de Invalidación
      ];



      // Mapear los datos filtrados a filas formateadas
      const rows = filteredData.map(row => {

        const tipoDocumento = (() => {
          if (row.id_tipo_doc_fiscal == "10") {
            return "CCF";
          } else if (row.id_tipo_doc_fiscal == "11") {
            return "FAC";
          } else if (row.id_tipo_doc_fiscal == "12") {
            return "FEX";
          } else if (row.id_tipo_doc_fiscal == "13") {
            return "NCR";
          } else {
            return "";
          }
        })();


        return [
          this.formatDate(row.fecha), // A: Fecha Emisión (DD/MM/AAAA)
          row.sello_recepcion, // B: Número de Serie
          row.codigo_generacion, // C: Número de Documento
          row.numero_control, // D: Número de Control
          tipoDocumento, // E: Tipo de Documento (FEX)
          row.nit || "", // F: NIT Cliente sin guiones (Solo si id_identificador === "1")
          row.nombre || "", // G: Nombre Cliente
          row.correo1 || "", // H: Correo 1
          row.direccion || "", // I: Dirección
          row.registro || "", // J: Registro
          row.iva || "0.00", // K: Débito Fiscal
          row.descuento || "", // L: Descuento
          row.gravadas || "", // M: Gravadas
          row.exentas || "", // N: Exentas
          row.no_sujetas || "", // O: No Sujetas
          row.retencion || "", // P: Retención
          row.percepcion || "", // Q: Percepción
          row.total_operacion || "", // R: Tipo de Operación
          row.total_pagar || "", // S: Total a Pagar
          row.dui || "", // T: DUI Cliente (Solo si id_identificador === "2")
          row.resolucion_invalidacion || "", // U: Resolución de Invalidación
        ].join(";");
      });


      return [header.join(";"), ...rows].join("\n");
    },



    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${day}/${month}/${year}`;
    },


  }
}
</script>


<style scoped>
#myPDF {
  width: 100%;
  height: 100%;
}


.v-btn {
  width: 190px;
  height: 190px;
  color: white;
}

.button-image {
  width: 140px;
  height: 140px;
}

.v-dialog {
  max-width: 400px;
}

.button-custom:hover {
  transform: scale(1.1);
}

.dialog-custom {
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
}

.actions-custom {
  justify-content: center;
  padding: 16px;
}

.btn-custom {
  border-radius: 12px;
  margin: 8px;
  transition: background-color 0.3s ease;
}

.btn-custom:hover {
  background-color: #45a049;
}

.btn-custom-cancel {
  color: #757575;
  background-color: #f0f0f0;
  border-radius: 12px;
  margin: 8px;
  transition: background-color 0.3s ease;
}

.btn-custom-cancel:hover {
  background-color: #d3d3d3;
}

.button-label {
  margin-top: 8px;
  font-size: 18px;
  font-weight: bold;
  animation: fadeIn 0.5s ease;
  text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
}

.v-dialog__content {
  padding: 0;

}
</style>*/